export default {"src":"/_next/static/media/search.1658458b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};